import { ChevronRightIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import { Link } from "react-router-dom";

type Page = {
    name: string;
    href?: string;
    truncate?: boolean;
};

export function Breadcrumbs({
    pages,
    className,
}: {
    pages: Page[];
    className?: string;
}) {
    return (
        <nav
            className={clsx("flex min-w-0", className)}
            aria-label="Breadcrumb"
        >
            <ol
                role="list"
                className={clsx(
                    "flex flex-nowrap",
                    "min-w-0 items-center space-x-3",
                )}
            >
                {pages.map((page, i) => (
                    <li
                        key={page.name}
                        className={clsx(
                            page.truncate ? "min-w-0 shrink" : "shrink-0",
                        )}
                    >
                        <div className="flex min-w-0 items-center">
                            {i > 0 && (
                                <ChevronRightIcon
                                    className="size-5 shrink-0 text-gray-400"
                                    aria-hidden="true"
                                />
                            )}
                            {page.href && (
                                <Link
                                    to={page.href}
                                    className={clsx(
                                        "text-link block",
                                        page.truncate && "min-w-0 truncate",
                                        i > 0 && "ml-3",
                                    )}
                                    aria-current={"page"}
                                >
                                    {page.name}
                                </Link>
                            )}
                            {!page.href && (
                                <p
                                    className={clsx(
                                        "ui-element block",
                                        "subdued",
                                        page.truncate && "min-w-0 truncate",
                                        i > 0 && "ml-3",
                                    )}
                                >
                                    {page.name}
                                </p>
                            )}
                        </div>
                    </li>
                ))}
            </ol>
        </nav>
    );
}
